import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { dealerService } from '../services/api';

function DealerLocator() {
  const [dealers, setDealers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    loadDealers();
  }, []);

  const loadDealers = async () => {
    try {
      const data = await dealerService.index();
      setDealers(data.data || data || []);
    } catch (error) {
      console.error('Error loading dealers:', error);
    } finally {
      setLoading(false);
    }
  };

  const filtered = dealers.filter((d) =>
    (d.name || '').toLowerCase().includes(search.toLowerCase()) ||
    (d.city || '').toLowerCase().includes(search.toLowerCase()) ||
    (d.state || '').toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="text-xl font-bold text-gray-900">Ortus</Link>
          <div className="flex gap-4">
            <Link to="/shop" className="text-blue-600">Shop</Link>
            <Link to="/login" className="text-blue-600">Login</Link>
          </div>
        </div>
      </nav>

      <main className="max-w-6xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold mb-6">Dealer Locator</h1>
        <input
          type="text"
          placeholder="Search by name, city, or state"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-full max-w-md border rounded p-3 mb-8"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((dealer) => (
            <div key={dealer.id} className="bg-white p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold mb-2">{dealer.name}</h3>
              <p className="text-sm text-gray-600 mb-1">{dealer.address}</p>
              <p className="text-sm text-gray-600 mb-1">{dealer.city}, {dealer.state} {dealer.postal_code}</p>
              <p className="text-sm text-gray-600 mb-1">{dealer.phone}</p>
              {dealer.website && (
                <a href={dealer.website} target="_blank" rel="noopener noreferrer" className="text-blue-600 text-sm">Website</a>
              )}
              {dealer.services && dealer.services.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-2">
                  {dealer.services.map((s, i) => (
                    <span key={i} className="text-xs bg-gray-100 px-2 py-1 rounded">{s}</span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
        {filtered.length === 0 && <p className="text-gray-500 mt-4">No dealers found.</p>}
      </main>
    </div>
  );
}

export default DealerLocator;
